<div fxLayoutAlign="space-between center">
  <h1>Inscrições</h1>
  <div>
    <button mat-raised-button color="primary" (click)="exportar()"><mat-icon>save_alt</mat-icon> Exportar</button>
  </div>
</div>

<mat-form-field appearance="outline" fxFill>
  <mat-icon matPrefix>search</mat-icon>
  <mat-label>Pesquisar</mat-label>
  <input matInput type="search" placeholder="" #input />
</mat-form-field>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>#</th>
      <td mat-cell data-label="#" *matCellDef="let row">{{ row.id }}</td>
    </ng-container>
    <ng-container matColumnDef="discente">
      <th mat-header-cell *matHeaderCellDef>Discente</th>
      <td mat-cell data-label="Discente" *matCellDef="let row">
        {{ row.nomeAluno }}<br />
        {{ row.cpfAluno }}
      </td>
    </ng-container>
    <ng-container matColumnDef="disciplina">
      <th mat-header-cell *matHeaderCellDef>Disciplina</th>
      <td mat-cell data-label="Disciplina" *matCellDef="let row">
        {{ row.nomeCampus }} - {{ row.siglaCampus }}<br />
        {{ row.idDepartamento }} - {{ row.nomeDepartamento }}<br />
        {{ row.idDisciplina }} - {{ row.nomeDisciplina }} - {{ row.codigoDisciplina }}<br />
        {{ row.duracao }} - {{ row.cargaHoraria }}h
      </td>
    </ng-container>
    <ng-container matColumnDef="inscricao">
      <th mat-header-cell *matHeaderCellDef>Inscrição</th>
      <td mat-cell data-label="Inscrição" *matCellDef="let row">
        {{ row.data | date : 'dd/MM/yyyy HH:mm:ss' }}<br />
        {{ row.ano }}<br />
        {{ row.inscricaoSituacao }}<br />
        {{ row.semestre }}
      </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="basic" [matMenuTriggerFor]="menu" title="Opções">
          <mat-icon>settings</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item color="basic" (click)="plano(row.id)" title="Plano">
            <mat-icon>more_time</mat-icon><span>Plano</span>
          </button>
          <button mat-menu-item color="basic" (click)="documentos(row.id)" title="Documentos">
            <mat-icon>picture_as_pdf</mat-icon><span>Documentos</span>
          </button>
          <button mat-menu-item color="basic" (click)="certificadoDiscente(row.id)" title="Certificado discente">
            <mat-icon>fact_check</mat-icon><span>Certificado discente</span>
          </button>
          <button mat-menu-item color="basic" (click)="certificadoDocente(row.id)" title="Certificado docente">
            <mat-icon>fact_check</mat-icon><span>Certificado docente</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
    <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="5">
        <span *ngIf="input.value">Nenhum registro encontrado para a pesquisa: "{{ input.value }}"</span>
        <span *ngIf="!input.value">Nenhum registro disponível</span>
      </td>
    </tr>
  </table>
  <mat-paginator
    [length]="totalElements"
    [pageSize]="10"
    [pageSizeOptions]="[10, 20, 50, 100]"
    showFirstLastButtons></mat-paginator>
</div>
